import { useApiClient } from '../api';

import { useMutation } from '@tanstack/react-query';
import { parseError } from '../utils/error-handler';
import { CancelPaymentDto, CancelPaymentV2Request, ErrorMessage } from '../../generated-api';

const useMutateCancelPayment = () => {
  const apiClient = useApiClient();
  return useMutation<CancelPaymentDto, ErrorMessage, CancelPaymentV2Request>({
    mutationFn: async (cancelPaymentRequest: CancelPaymentV2Request) =>
      apiClient.PaymentCancelledController.cancelPaymentV2(cancelPaymentRequest, {
        headers: { 'Content-Type': 'application/json' },
      }).catch(parseError),
  });
};

export default useMutateCancelPayment;
